import { useState } from 'react';
import { Users, Search, Sparkles, Activity } from 'lucide-react';
import ClientManager from './ClientManager';
import KeywordManager from './KeywordManager';
import DiscoveryPanel from './DiscoveryPanel';
import ApiUsagePanel from './ApiUsagePanel';

const TABS = [
  { id: 'clients', label: 'Clients', icon: Users },
  { id: 'keywords', label: 'Keywords', icon: Search },
  { id: 'discovery', label: 'Discovery', icon: Sparkles },
  { id: 'api-usage', label: 'API Usage', icon: Activity },
];

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState('clients');

  return (
    <div className="space-y-4 sm:space-y-6" data-testid="admin-panel">
      {/* Tab Navigation */}
      <div className="flex items-center gap-1 sm:gap-2 border-b border-[#1E2D45] pb-3 sm:pb-4 overflow-x-auto">
        {TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-syne font-semibold text-xs sm:text-sm transition-all whitespace-nowrap ${
                activeTab === tab.id
                  ? 'bg-[#1A2338] text-[#E2E8F0] border border-[#0070F3]'
                  : 'text-[#94A3B8] hover:text-[#E2E8F0] border border-transparent'
              }`}
              data-testid={`admin-tab-${tab.id}`}
            >
              <Icon size={14} className="sm:w-4 sm:h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      {activeTab === 'clients' && <ClientManager />}
      {activeTab === 'keywords' && <KeywordManager />}
      {activeTab === 'discovery' && <DiscoveryPanel />}
      {activeTab === 'api-usage' && <ApiUsagePanel />}
    </div>
  );
}
